import React, { Component } from 'react';
import { get } from 'lodash';

export default class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    componentDidCatch(error) {
        // Display fallback UI
        this.setState({ hasError: true });
        if (window.Rollbar) {
            window.Rollbar.error(get(error, 'message', 'Unknown error has his the ErrorBoundary!'), { error });
        }
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return <h1>Something went wrong. We've been notified.</h1>;
        }
        return this.props.children;
    }
}



// WEBPACK FOOTER //
// ./src/ErrorBoundary.js